export default __webpack_public_path__ + "static/media/Press-Release-May-15-2026.fce1e361.pdf";